(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4599],{

/***/ 8298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_views_parts_commons_Head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(656);
/* harmony import */ var _src_views_providers_RequiredAuthProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4574);
/* harmony import */ var _views_pages_ArcadeMachinesManagerPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9920);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);







var Page = function Page() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_views_parts_commons_Head__WEBPACK_IMPORTED_MODULE_0__/* .Head */ .F, {
      title: "Craft"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_views_providers_RequiredAuthProvider__WEBPACK_IMPORTED_MODULE_1__/* .RequiredAuthProvider */ .B, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_views_pages_ArcadeMachinesManagerPage__WEBPACK_IMPORTED_MODULE_2__/* .ArcadeMachinesManagerPage */ .F, {
        activeTab: "Craft"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Page);

/***/ }),

/***/ 6584:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arcade-machines/craft",
      function () {
        return __webpack_require__(8298);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4804,9826,1708,4050,942,6062,3276,3092,7794,9920,9774,2888,179], function() { return __webpack_exec__(6584); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);